import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing-module';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppMaterialComponentsModule } from './app-material-components';

export const options: Partial<IConfig> | (() => Partial<IConfig>) = {};
import {
  OptionSetsApiService,
  LeadApiService
} from './data-services';
import {
  OptionSetsGqlService,
  LeadGqlService
} from './data-services/dynamics';
import {
  ApiService,
  AppLoadService,
  DialogSolutionDeployingComponent,
  HelpApiService,
  HelpGqlService} from '@ebb-v2/ebb-integration';
import { SignUpAppComponent } from './app.component';
import { DialogHelpComponent } from './modules/signup/components/dialog-help.component';
import { IConfig, NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { APOLLO_PROVIDERS } from './apollo.config';

export function get_environ_settings(appLoadService: AppLoadService) {
  return () => appLoadService.getEnvironSettings();
}

@NgModule({ declarations: [ SignUpAppComponent,
        DialogSolutionDeployingComponent,
        DialogHelpComponent
     
    ],
     imports: [BrowserModule,
        BrowserAnimationsModule,
        CommonModule,
        AppMaterialComponentsModule,
        AppRoutingModule,
        FormsModule,
        HttpClientModule,
        NgxMaskDirective, NgxMaskPipe ], providers: [
        ApiService, provideNgxMask(),
        AppLoadService,
        {
            provide: APP_INITIALIZER,
            useFactory: get_environ_settings,
            deps: [AppLoadService],
            multi: true
        },
        { provide: OptionSetsApiService, useClass: OptionSetsGqlService },
        { provide: LeadApiService, useClass: LeadGqlService },
        { provide: HelpApiService, useClass: HelpGqlService },
        ...APOLLO_PROVIDERS
    ] , bootstrap: [SignUpAppComponent],})
export class SignUpAppModule {}
